<!-- BEGIN #content -->
<div id="content" class="app-content p-0">
  <div class="h-100 position-relative">
    <app-map #burnListMap 
             [mapheight]="mapHeight" 
             (mapInitComplete)="onMapInit($event)">
    </app-map>
  </div>
</div>
<!-- END #content -->
